import { File, Link } from "lucide-react";
import { NotesActivity } from "../models/activity.model";
import { BaseActivityCard } from "./BaseActivityCard";
import { Button } from "@/components/ui/button";
import { DocumentationList } from "@/components/ui/documentation-list";
import { MediaGallery } from "@/components/ui/media-gallery";

interface NotesCardProps {
  activity: NotesActivity;
  onEdit: (activity: NotesActivity) => void;
  onDelete: (activity: NotesActivity) => void;
  onDuplicate?: (activity: NotesActivity) => void;
  onExpand?: () => void;
  isReadOnly?: boolean;
}

export const NotesCard = ({
  activity,
  onEdit,
  onDelete,
  onDuplicate,
  onExpand,
  isReadOnly = false
}: NotesCardProps) => {
  const renderAlwaysVisible = () => (
    <>
      {/* Description */}
      {activity.description && (
        <p className="text-sm text-gray-600 leading-relaxed">{activity.description}</p>
      )}
    </>
  );

  const renderCollapsible = () => (
    <>
      {/* Media Gallery */}
      <MediaGallery media={activity.media || []} />

      {/* Documentation */}
      <DocumentationList documentation={activity.documentation || []} />

      {/* Action Buttons */}
      <div className="flex items-center justify-between">
        <div className="flex gap-3">
          {/* Link Button */}
          {activity.link && (
            <Button
              variant="ghost"
              size="sm"
              className="rounded-xl"
              onClick={() => window.open(activity.link, '_blank')}
            >
              <Link className="h-5 w-5 mr-2 flex-shrink-0" />
              <span className="truncate max-w-[200px] inline-block">
                {activity.link}
              </span>
            </Button>
          )}
        </div>
      </div>

    </>
  );

  return (
    <BaseActivityCard
      activity={activity}
      onEdit={onEdit}
      onDelete={onDelete}
      onDuplicate={onDuplicate}
      onExpand={onExpand}
      isReadOnly={isReadOnly}
    >
      {{
        alwaysVisible: renderAlwaysVisible(),
        collapsible: renderCollapsible()
      }}
    </BaseActivityCard>
  );
};
